import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserApiService } from 'src/app/services/api/user-api.service';

@Component({
  selector: 'app-wechat-official-account-modal',
  templateUrl: './wechat-official-account-modal.component.html',
  styleUrls: ['./wechat-official-account-modal.component.scss'],
})
export class WechatOfficialAccountModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: UserApiService
  ) {}

  url: any = null;
  ngOnInit(): void {
    this.getWXAuthConnect();
  }

  loading = false;
  refresh = false;
  async getWXAuthConnect() {
    this.refresh = false;
    try {
      this.loading = true;
      const r = await this.api.getWXAuthConnect();
      if (r.status === 0) {
        this.url = r.data;
      } else {
        this.refresh = true;
      }
    } catch (error) {
    } finally {
      this.loading = false;
      this.getWXAuthConnectStatus();

      const intervalId = setInterval(() => {
        this.getWXAuthConnectStatus();
      }, 1000);

      setTimeout(() => {
        clearInterval(intervalId);
        this.refresh = true;
      }, 30000);
    }
  }

  async getWXAuthConnectStatus() {
    try {
      this.loading = true;
      const r = await this.api.getWXAuthConnectStatus();
      if (r.data === 1) {
        window.location.reload();
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  refreshQrcode() {
    this.getWXAuthConnect();
  }
}
